import { useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { CrmObjectRow } from '../LinkCrmObjectModal/CrmObjectRow';
import type { FlexDataLink } from 'pages/flex-data/flex-data-links/types';
import { sortLinkedObjects } from '../utils';

interface LinkedObjectsListProps {
  linkedObjects: FlexDataLink[];
  contentId: string;
}

export function LinkedObjectsList({ linkedObjects, contentId }: LinkedObjectsListProps) {
  const sorted = useMemo(() => sortLinkedObjects(linkedObjects), [linkedObjects]);

  return (
    <Stack direction="column" gap={1}>
      {sorted.map((obj) => (
        <CrmObjectRow key={obj.objectId} obj={obj} contentId={contentId} variant="linked" />
      ))}
    </Stack>
  );
}
